class Hubspot {
    identify(user) {
        if (user.accepted_cookies === true && typeof window !== 'undefined' && user.email) {
            const _hsq = (window._hsq = window._hsq || []);
            _hsq.push(['identify', { email: user.email, id: user.id }]);
            if (user.email && user.hubspot_user_token) {
                window.hsConversationsSettings = {
                    identificationEmail: user.email,
                    identificationToken: user.hubspot_user_token,
                };
            }
            console.log('Chat identity set');
        }
        this.refreshChat();
    }

    removeChat() {
        if (
            window.HubSpotConversations &&
            window.HubSpotConversations.widget.status() &&
            window.HubSpotConversations.widget.status().loaded
        ) {
            window.HubSpotConversations.widget.remove();
        }
    }

    refreshChat() {
        // load or refresh chat
        const status =
            window.HubSpotConversations &&
            window.HubSpotConversations.widget &&
            window.HubSpotConversations.widget.status();

        if (status && status.loaded) {
            console.log('Chat already loaded, refreshing...');
            window.HubSpotConversations.widget.refresh();
        } else {
            console.log('Chat not loaded, loading...');
            window && window.HubSpotConversations && window.HubSpotConversations.widget.load();
        }
    }
}

export default new Hubspot();
